

import { Grid } from "@material-ui/core";
import BackupIcon from '@mui/icons-material/Backup';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useEffect, useState } from 'react';

import 'dayjs/locale/en-gb';

import { Box } from "@material-ui/core";
import ReplyIcon from '@mui/icons-material/Reply';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';

import 'dayjs/locale/en-gb';


import Swal from 'sweetalert2';



const PdfUpload2 = ({FILEID,submitValue,setSubmitValue}) => {

  useEffect(() => {
    if(submitValue.p_id === "" || !submitValue.hasOwnProperty('p_id')){localStorage.removeItem("savedPDF2");localStorage.removeItem("savedPDFName2");}
    else{
      const saved = localStorage.getItem("savedPDF2");
      const fileName = localStorage.getItem("savedPDFName2");
    
    if (saved) {
      const file = base64ToFile(saved, fileName);
      setFileStore2(file);
      setFileURL2(URL.createObjectURL(file));
      setSubmitValue( prevValues => {
        return { ...prevValues,folio_bo_file2: file}
      })
    }
    }
    
  }, []);
  
//  console.log(submitValue);
  
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height:"80vh",
        bgcolor: 'background.paper',
        border: '2px solid #eee',
        boxShadow: '2px 2px 2px 2px #eee',
        borderRadius:"10px",
        p: 4
      };
     const [fileURL2,setFileURL2] = useState("");

     const [fileStore2,setFileStore2] = useState();
     const [open,setOpen] = useState(false);
     const fileToBase64 =  (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
      const base64ToFile = (base64String, fileName = "file.pdf") => {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
      
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
      // console.log([u8arr])
        return new File([u8arr], fileName, { type: mime });
      };
    const handleFileUploadPDF = async (event) => {
          
        const file = event.target.files[0];
        
        
        if(file && file.type === "application/pdf")
          {
            setFileURL2(URL.createObjectURL(file));
            if ( file.type === "application/pdf" ) 
              {
                if((file.size/1024)>1024)
                    {
                      Swal.fire({
                        icon: 'warning',
                        title: 'The File is greater than 1 MB! ',
                        showConfirmButton: true,
                        customClass: {
                            container: 'my-swal'
                          },
                        // timer: 3000
                      })
                      return;
                    }
                    else{
    
                        
                        const base64 = await fileToBase64(file);
                        setFileStore2(file);
                        localStorage.setItem("savedPDF2", base64);
                        localStorage.setItem("savedPDFName2",file.name)
                        setSubmitValue( prevValues => {
                            return { ...prevValues,pfil: file}
                          })
                          console.log(file);
                        setOpen(true); 
                    }
          }      
       
           
        }
        else
        {
          Swal.fire({
            icon: 'warning',
            title: 'File does not support. You must use .pdf ',
            showConfirmButton: true,
            customClass: {
                container: 'my-swal'
              },
            // timer: 3000
          })
          return;
        }
        
      };
     

  const handleOpenPreview = () =>{
      return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={()=>{setOpen(false);} }
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={open}>
        <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
            <h3>PDF PREVIEWER </h3>
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                {fileURL2 ? (
                    <iframe
                        src={fileURL2}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                      />
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            border: '2px dashed rgba(0, 0, 0, .3)',
                            display: 'flex',
                            fontSize: '2rem',
                            height: '100%',
                            justifyContent: 'center',
                            width: '100%',
                        
                        }}
                    >
                        Please upload a PDF file to preview.
                    </div>
                )}
                
                <Button type="button" onClick={()=>{setOpen(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                </Box>
        </Box>
        </Fade>
    </Modal>
      )

      
    }
  return (
    <div>
        <h4 style={{color:"slateblue"}}>Documents Upload (Maximum Limit 1 MB) : </h4>
                      <Grid container spacing={2} style={{padding:"20px"}} >
                      <Grid item lg={6} md={6} sm={12} xs={12} for={FILEID}  style={{border:"1px dashed gray"}}> <label
                                        for={FILEID}
                                        style={{ color: "black", border:"1px solid slateblue" }}
                                        className="btn btn-warning btn-lg"
                                        ><BackupIcon style={{fill:'black'}} /> Upload PDF File2</label>
                                        <input
                                          id={FILEID}
                                          name="folio_bo_file2"
                                          type="file"
                                          accept="application/pdf"
                                          onChange={(e)=>{
                                              handleFileUploadPDF(e);
                                          }}
                                          style={{ display: "none",visibility:"none" }}
                                        />
                                        {fileStore2 ? 
                                        <>
                                        <button className="btn btn-danger btn-lg" type="button" style={{color:"white", border:"2px solid white", marginLeft:"2px"}}
                                        onClick={()=>{
                                          Swal.fire({
                                            icon: 'question',
                                            title: 'Are you sure about removing the file selected?',
                                            showConfirmButton: true,
                                            confirmButtonText: 'Yes',
                                            showCancelButton: true,
                                            cancelButtonText: "No",
                                            customClass: {
                                                container: 'my-swal'
                                              },
                                          }).then((res)=>{
                                            if(res.isConfirmed)
                                            {
                                              setFileStore2("");
                                              setFileURL2("");
                                              setSubmitValue( prevValues => {
                                                return { ...prevValues,folio_bo_file2: ""}
                                              });
                                              localStorage.removeItem("savedPDF2");
                                              localStorage.removeItem("savedPDFName2");
                                            }
                                          })
                                        }}
                                        >X</button>
                                        <h6>{fileStore2?.name}</h6> 
                                        <h6>{Math.round(fileStore2?.size/1024)} KB </h6> 
                                        
                                        </>
                                        : null}
                                        </Grid>
                                        {open && handleOpenPreview()}
                                  <Grid item lg={6} md={6} sm={12} xs={12} style={{border:"1px dashed gray"}}>
                                  
                                    <button className="btn btn-primary btn-lg" type="button" style={{color:"white",border:"1px solid white"}} onClick={()=>{setOpen(true);}}><RemoveRedEyeIcon/> Preview Uploaded PDF</button>
                                          {open && handleOpenPreview()}
                                  </Grid>
                                        </Grid>
    </div>
  )
}

export default PdfUpload2